import React, { FC, useState } from 'react';
import ProtectWithLogin from 'src/components/ProtectWithLogin/ProtectWithLogin';
import cx from 'classnames';
import Typo from 'src/components/Typography/Typo';
import { TCommentActionsContainerProps } from './CommentActionsContainer';
import { LikeButton } from '../../LikeButton/LikeButton';

type TCommentLikeButtonProps = Pick<TCommentActionsContainerProps, 'likesCount' | 'userAlreadyLikedComment'> & {
  onLikeCounterClick: () => void;
  onClick: () => void | Promise<void>;
};

const CommentLikeButton: FC<TCommentLikeButtonProps> = ({
  likesCount,
  onLikeCounterClick,
  onClick,
  userAlreadyLikedComment,
}) => {
  const [isActionInProgress, setIsActionInProgress] = useState(false);

  return (
    <div className="flex items-center">
      <ProtectWithLogin>
        <LikeButton
          onClick={async () => {
            if (onClick) {
              setIsActionInProgress(true);
              await onClick();
              setIsActionInProgress(false);
            }
          }}
          isActive={userAlreadyLikedComment}
          isLoading={isActionInProgress}
        />
      </ProtectWithLogin>
      <button
        className={cx('min-w-[15px] text-gray-600 peer-active:-ml-[6px]', {
          'hover:underline hover:underline-offset-2': !!likesCount,
        })}
        onClick={onLikeCounterClick}
        disabled={!likesCount || isActionInProgress}
      >
        <Typo
          className={cx([
            {
              '!stroke-orange-500 !text-orange-500 peer': userAlreadyLikedComment,
            },
            '!text-base text-gray-600 peer-active:-ml-[6px]',
          ])}
          variant="small-p"
        >
          {likesCount?.toString()}
        </Typo>
      </button>
    </div>
  );
};

export default CommentLikeButton;
